import { FC, useState } from "react";

import { Button, Card, Field, Input, Spinner } from "@fluentui/react-components";
import { nodeServer } from "../constants";

interface MainProps {}

const ForgotPasswordEmail: FC<MainProps> = () => {
    const [email, setEmail] = useState<string>("");
    const [sent, setSent] = useState<boolean>(false);
    const [inProgress, setInProgress] = useState<boolean>(false);

    const sendEmail = async () => {
        setInProgress(true);
        console.log("Send email to reset password");
        const result = await fetch(nodeServer + `password/forgot/${encodeURIComponent(email)}`);
        console.log(result);
        setSent(!sent);
        setInProgress(false);
    };

    return (
        <>
            <Card>
                <h2>Forgot Password</h2>
                {!sent ? (<>
                <p>
                    If you've forgotten your password, enter the email you
                    registered with and we'll send you a link in your email to
                    reset your password.
                </p>
                <p>
                    Please, ensure all email from 2yc3.org addresses are not
                    blocked or sent to spam by your email provider.
                </p>
                <Field label={"Email Address"}>
                    <Input
                        value={email}
                        onChange={(_, data) => {
                            setEmail(data.value);
                        }}
                        placeholder="Enter your email address"
                    />
                </Field>
                <Button appearance="primary"
                    onClick={() => sendEmail()}>Submit</Button>
                </>) : (
                    <>
                    <p>
                    An email has been sent to <b>{email}</b> with a link to reset your password.  Please check your email. 
                     Wait a few minutes and check your spam folder if you do not see the email.
                </p>
                    </>

                )}
            </Card>
            {inProgress && 
            <div style={{position:"absolute", top:0, left: 0, right: 0, bottom:0, margin:'auto'}}>
                <div style={{position:'absolute', top:0, left: 0, right: 0, bottom:0, background:'black', opacity:'30%', height:'100%'}}></div>
                <div style={{display:'flex', width:'100%', height:'100%', justifyContent:'center', alignItems:'center'}}>
                    <Spinner  />
                </div>
            </div>}
            
           
        </>
    );
};

export default ForgotPasswordEmail;
